var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 373,
    viewBox: "0 0 532 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.217 11.2949C496.088 17.417 514.062 35.39 520.184 58.2606C531.247 99.6726 531.292 186.126 531.292 186.126C531.292 186.126 531.292 272.58 520.184 313.993C514.062 336.863 496.088 354.836 473.217 360.957C431.807 372.065 265.676 372.065 265.676 372.065C265.676 372.065 99.5476 372.065 58.1355 360.957C35.265 354.836 17.292 336.863 11.1699 313.993C0.0625038 272.58 0.0625 186.126 0.0625 186.126C0.0625 186.126 0.0625038 99.6726 11.1699 58.2606C17.292 35.39 35.265 17.417 58.1355 11.2949C99.5476 0.187504 265.676 0.1875 265.676 0.1875C265.676 0.1875 431.807 0.187504 473.217 11.2949ZM350.514 186.134L212.503 265.809V106.458L350.514 186.134Z",
    fill: "#040E64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/YT.f0b953a0a210e4daae06a709d5cc48fb.svg";
export { ForwardRef as ReactComponent };